<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <WinesForm @submit-requested="submitRequested"></WinesForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import WinesForm from './WinesForm.vue'

  export default {
  components: { WinesForm },
  methods: {
    ...mapActions('wines', ['postWine']),
    submitRequested (input) {
      this.postWine(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 